import { computed, reactive } from 'vue';

interface PartnerInfo {
    id: number;
    name: string;
}

const state = reactive<PartnerInfo>({
    id: null,
    name: null
});

export const usePartnerInfo = () => {
    const setPartnerInfo = (id: number, name: string): void => {
        state.id = id;
        state.name = name;
    };

    return {
        id: computed<number>(() => state.id),
        name: computed<string>(() => state.name),
        setPartnerInfo
    };
};
